
import { defineComponent, PropType, ref } from 'vue';
import { TranslateFunc } from '@/catalogs/composables/setupComponent';
import {
  CatalogDetail,
  CatalogProductQuantityItem,
  ConfigurationOptionSearchResult,
} from '@/common/services/swagger/index.defs';

import { ConfiguredProductsCommand } from '@/catalogs/api/runtime/CommandExecutor';
import PIS from '@/common/api/PIS';
import { Instance } from '@/catalogs/api/Instance';
import Icon from '@/common/components/Icon.vue';
export default defineComponent({
  components: { Icon },
  props: {
    t: { type: Function as PropType<TranslateFunc>, required: true },
    instanceId: String,
    qty: { type: Object as PropType<CatalogProductQuantityItem>, required: true },
    configuredProductId: { type: String, required: true },
    productId: { type: String, required: true },
    catalog: { type: Object as PropType<CatalogDetail>, required: true },
  },
  setup(props) {
    const instance = PIS.Catalogs.getInstance(props.instanceId) as Instance;
    const configurator = ref<ConfigurationOptionSearchResult>();
    const expanded = ref(false);

    const loadConfiguredOptions = async () => {
      try {
        if (expanded.value === true) {
          expanded.value = false;
          return;
        }

        if (configurator.value) {
          expanded.value = true;
          return;
        }

        var catalogId = props.catalog.catalogId;

        if (!catalogId) {
          return;
        }

        expanded.value = true;

        const result = (await instance.commandExecutor.execute(
          new ConfiguredProductsCommand({
            configuredProductId: props.configuredProductId,
            catalogId: catalogId,
            productId: props.productId,
            unitOfMeasure: props.qty.unitOfMeasure,
          }),
        )) as ConfigurationOptionSearchResult;

        if (result) {
          configurator.value = result;
        }
      } catch {
        //
      }
    };

    return { loadConfiguredOptions, configurator, expanded };
  },
});
